<div [formGroup]="form" *ngIf="isVisible">
  <div>
    <form-field
      class="front mb-0"
      label="New IBAN *"
      i18n-label="@@support.bankTicket.newIban.label"
    >
      <input
        required
        type="text"
        formControlName="iban"
        placeholder="Fill out the new IBAN"
        i18n-placeholder="@@support.bankTicket.newIban.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="iban?.errors?.required && iban?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Bank Name *"
      i18n-label="@@support.bankTicket.newBankName.label"
    >
      <input
        required
        type="text"
        formControlName="bankName"
        placeholder="Fill out the new bank name"
        i18n-placeholder="@@support.bankTicket.newBankName.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="bankName?.errors?.required && bankName?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Account Holder Name *"
      i18n-label="@@support.bankTicket.newAccountHolderName.label"
    >
      <input
        required
        type="text"
        formControlName="accountHolderName"
        placeholder="Fill out the new account holder name"
        i18n-placeholder="@@support.bankTicket.newAccountHolderName.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="accountHolderName?.errors?.required && accountHolderName?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Branch Name *"
      i18n-label="@@support.bankTicket.newBranchName.label"
    >
      <input
        required
        type="text"
        formControlName="branchName"
        placeholder="Fill out the new branch name"
        i18n-placeholder="@@support.bankTicket.newBranchName.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="branchName?.errors?.required && branchName?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Bank Address *"
      i18n-label="@@support.bankTicket.newBankAddress.label"
    >
      <input
        required
        type="text"
        formControlName="bankAddress"
        placeholder="Fill out the new bank address"
        i18n-placeholder="@@support.bankTicket.newBankAddress.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="bankAddress?.errors?.required && bankAddress?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Account Number *"
      i18n-label="@@support.bankTicket.newAccountNumber.label"
    >
      <input
        required
        type="text"
        formControlName="accountNumber"
        placeholder="Fill out the new account number"
        i18n-placeholder="@@support.bankTicket.newAccountNumber.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="accountNumber?.errors?.required && accountNumber?.touched"
      >* This field is required.</small
    >
    <small
      i18n="@@support.numbersPatternError"
      class="text-danger"
      *ngIf="accountNumber?.errors?.pattern && accountNumber?.touched"
      >* Please enter only numbers.</small
    >
    <form-field
      class="front mb-0 mt-3"
      label="New Swift Code *"
      i18n-label="@@support.bankTicket.newSwiftCode.label"
    >
      <input
        required
        type="text"
        formControlName="swiftCode"
        placeholder="Fill out the new swift code"
        i18n-placeholder="@@support.bankTicket.newSwiftCode.placeholder"
      />
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="swiftCode?.errors?.required && swiftCode?.touched"
      >* This field is required.</small
    >
    <file-uploader
      [maxSize]="1024 * 5"
      [allowedTypes]="['png', 'jpg', 'jpeg']"
      class="w-100 mt-3"
      data-testid="support-selfie-input"
      (select)="onFileSelect($event, 'personalPhoto')"
      (remove)="onFileRemove('personalPhoto')"
    >
      <input
        #file
        type="file"
        class="input"
        (click)="markAsTouched('personalPhoto')"
      />
      <ng-template #placeholder>
        <img
          src="assets/images/icons/upload-selfie.svg"
          alt="upload document icon"
        />
        <div class="text-primary pt-2 text-sm" i18n="@@support.selfie.label">
          Selfie *
        </div>
      </ng-template>
    </file-uploader>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="personalPhoto?.errors?.required && personalPhoto?.touched"
      >* This field is required.</small
    >
    <form-field
      class="front textarea mt-3"
      label="Ticket Message"
      i18n-label="@@support.message.label"
    >
      <textarea
        formControlName="message"
        placeholder="Enter your ticket message"
        rows="5"
        i18n-placeholder="@@support.message.placeholder"
      ></textarea>
    </form-field>
  </div>
</div>
